import { render } from "./popupIdentity.vue?vue&type=template&id=5d228238&scoped=true&ts=true"
import script from "./popupIdentity.vue?vue&type=script&lang=ts"
export * from "./popupIdentity.vue?vue&type=script&lang=ts"

import "./popupIdentity.vue?vue&type=style&index=0&id=5d228238&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d228238"]])

export default __exports__